import { trackFilterChange } from '../utils/tracking/searchBrowse/filterTracking';

export const ADD_AND_APPLY_FILTER = 'ADD_AND_APPLY_FILTER';
export function addAndApplyFilter(filterName, filterValue, isFromTypeahead = false) {
    trackFilterChange({ filterName, filterValue, isFromTypeahead });
    return {
        type: ADD_AND_APPLY_FILTER,
        payload: { filterName, filterValue, isFromTypeahead },
    };
}

export const REMOVE_AND_APPLY_FILTER = 'REMOVE_AND_APPLY_FILTER';
export function removeAndApplyFilter(filterName, filterValue) {
    trackFilterChange({ filterName, filterValue, isDeselected: true });
    return { type: REMOVE_AND_APPLY_FILTER, payload: { filterName, filterValue } };
}

export const BATCH_ADD_AND_APPLY_FILTER = 'BATCH_ADD_AND_APPLY_FILTER';
export function batchAddAndApplyFilter(filterName, filterValues = []) {
    return {
        type: BATCH_ADD_AND_APPLY_FILTER,
        payload: { filterName, filterValues },
    };
}

export const BATCH_REMOVE_AND_APPLY_FILTER = 'BATCH_REMOVE_AND_APPLY_FILTER';
export function batchRemoveAndApplyFilter(filterNames = []) {
    return { type: BATCH_REMOVE_AND_APPLY_FILTER, payload: { filterNames } };
}

export const TOGGLE_FILTER_DISPLAY = 'TOGGLE_FILTER_DISPLAY';
export function toggleFilterDisplay(shown) {
    return { type: TOGGLE_FILTER_DISPLAY, filtersShown: shown };
}

export const CLEAR_FILTERS_BY_NAME = 'CLEAR_FILTERS_BY_NAME';
export function clearFiltersByName(filterName) {
    return { type: CLEAR_FILTERS_BY_NAME, payload: filterName };
}

export const ADD_APPLIED_FILTERS = 'ADD_APPLIED_FILTERS';
export function addAppliedFilters(payload) {
    return { type: ADD_APPLIED_FILTERS, payload };
}

export const TOGGLE_REQUEST_IN_FLIGHT = 'TOGGLE_REQUEST_IN_FLIGHT';
export function toggleRequestInFlight(payload) {
    return { type: TOGGLE_REQUEST_IN_FLIGHT, payload };
}

export const TOGGLE_HASH_FRAGMENT_RESOLVED = 'TOGGLE_HASH_FRAGMENT_RESOLVED';
export function toggleHashFragmentResolved(payload) {
    return { type: TOGGLE_HASH_FRAGMENT_RESOLVED, payload };
}

export const UPDATE_URI_REF = 'UPDATE_URI_REF';
export function updateUriRef(uriRef) {
    return { type: UPDATE_URI_REF, payload: uriRef };
}
export const UPDATE_ZIP_CODE = 'UPDATE_ZIP_CODE';
export function updateZipCode(zipCode) {
    return { type: UPDATE_ZIP_CODE, payload: zipCode };
}

export const SET_SEMANTIC_SEARCH_TERM = 'SET_SEMANTIC_SEARCH_TERM';
export function setSemanticSearchTerm(semanticSearchTerm) {
    return { type: SET_SEMANTIC_SEARCH_TERM, payload: semanticSearchTerm };
}
